export const MENU = {
  itemId: 1,
  enable: true,
  itemParentId: 0,
  itemGroup: 'BO_ADMIN',
  itemOrder: 0,
  itemName: 'MENU',
  itemType: 'NONE',
  itemAclHidden: true,
  itemEnable: false,
  itemVisible: false,
  itemChildren: [
    {
      itemId: 2,
      enable: true,
      itemParentId: 1,
      itemGroup: 'BO_ADMIN',
      itemOrder: 0,
      itemName: 'TOPBAR',
      itemType: 'NONE',
      itemAclHidden: true,
      itemEnable: false,
      itemVisible: false,
      itemChildren: [],
    },
    {
      itemId: 3,
      enable: true,
      itemParentId: 1,
      itemGroup: 'BO_ADMIN',
      itemOrder: 1,
      itemName: 'SIDEBAR',
      itemType: 'NONE',
      itemAclHidden: true,
      itemEnable: false,
      itemVisible: false,
      itemChildren: [
        {
          itemId: 4,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Home',
          itemType: 'NONE',
          itemCommand: 'dashboard',
          itemIcon: 'home',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [],
        },
        {
          itemId: 5,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Eligible Models',
          itemType: 'NONE',
          itemIcon: 'smartphone',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [
            {
              itemId: 6,
              enable: true,
              itemParentId: 3,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'List',
              itemType: 'NONE',
              itemCommand: 'devices',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 7,
              enable: true,
              itemParentId: 3,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Add',
              itemType: 'NONE',
              itemCommand: 'devices/add',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
          ],
        },
        {
          itemId: 8,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Replacement Matrix',
          itemType: 'NONE',
          itemCommand: 'replacement-matrix',
          itemIcon: 'repeat',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [],
        },
        {
          itemId: 10,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Admin Tables ',
          itemType: 'NONE',
          itemIcon: 'table',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [
            {
              itemId: 11,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Manufacturers',
              itemType: 'NONE',
              itemCommand: 'manufacturers',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 12,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Phone Types',
              itemType: 'NONE',
              itemCommand: 'phonetypes',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 14,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Sku Categories',
              itemType: 'NONE',
              itemCommand: 'skus',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 15,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Inventory Owners',
              itemType: 'NONE',
              itemCommand: 'inventory_owners',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 16,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Tiers',
              itemType: 'NONE',
              itemCommand: 'tiers',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
            {
              itemId: 17,
              enable: true,
              itemParentId: 10,
              itemGroup: 'BO_ADMIN',
              itemOrder: 0,
              itemName: 'Fee Structure',
              itemType: 'NONE',
              itemCommand: 'fees',
              itemAclHidden: false,
              itemEnable: true,
              itemVisible: true,
            },
          ],
        },
        {
          itemId: 9,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Exports',
          itemType: 'NONE',
          itemCommand: 'exports',
          itemIcon: 'upload',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [],
        },
        {
          itemId: 10,
          enable: true,
          itemParentId: 3,
          itemGroup: 'BO_ADMIN',
          itemOrder: 0,
          itemName: 'Import',
          itemType: 'NONE',
          itemCommand: 'imports',
          itemIcon: 'download',
          itemAclHidden: true,
          itemEnable: true,
          itemVisible: true,
          itemChildren: [],
        },
      ],
    },
  ],
};
